import PageTitle from "../elements/PageTitle";
import { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import ProgramInquiryForm from "../components/ProgramInquiryForm";
import { useLanguage } from "../i18n/LanguageContext";

const ProgramInquiry = () => {
  const { t } = useLanguage();
  const [ultimatePackage, setUltimatePackage] = useState(null);
  useEffect(() => {
    let active = true;
    apiClient.get("/packages").then(({ data }) => {
      if (active) setUltimatePackage((data.data || []).find((pkg) => pkg.is_ultimate_program) || null);
    }).catch(() => { if (active) setUltimatePackage(null); });
    return () => { active = false; };
  }, []);
  const inclusions = [
    "Comprehensive training questionnaire",
    "Goal assessment",
    "Personalized program design",
    "Weekly training structure",
    "Exercise selection",
    "Sets, reps and progression guidance",
    "Training instructions",
    "Full exercise video access",
    "Program delivered through HPA",
  ];
  return (
    <div className="page-content bg-white hpa-program-inquiry-page">
      <PageTitle activePage="Request a Program" parentTitle="Home" />
      <section className="content-inner">
        <div className="container">
          <section className="hpa-blueprint" aria-labelledby="hpa-blueprint-title">
            <div className="hpa-blueprint__intro">
              <div><span className="hpa-blueprint__eyebrow">{t("THE HYBRID PERFORMANCE PROGRAM")}</span>
                <h1 id="hpa-blueprint-title">{t("THE HYBRID BLUEPRINT")}</h1></div>
              {ultimatePackage && <strong className="hpa-blueprint__price"><small>{t("Personalized program")}</small>{ultimatePackage.currency} {ultimatePackage.price}</strong>}
            </div>
            <div className="hpa-blueprint__body">
              <div className="hpa-blueprint__promise">
                <span>{t("YOUR GOAL. YOUR BODY. YOUR SYSTEM.")}</span>
                <p>{t("A personalized training program designed around your goals, training experience, schedule, equipment and lifestyle.")}</p>
                <div className="hpa-blueprint__access"><i className="fa-solid fa-play" />
                  <span><strong>{t("Complete HPA delivery")}</strong><small>{t("Your program and exercise videos, organized in one place.")}</small></span></div>
              </div>
              <div className="hpa-blueprint__includes"><h2>{t("Your blueprint includes")}</h2>
                <ul>{inclusions.map((item) => <li key={item}><i className="fa-solid fa-check" /><span>{t(item)}</span></li>)}</ul>
              </div>
            </div>
          </section>
          <div className="section-head style-1 text-center hpa-blueprint-form-heading">
            <span className="sub-title">{t("Start your application")}</span>
            <h2 className="title">{t("Request Your Program")}</h2>
            <p className="p-big mx-auto">{t("Tell us about your goals and training background. Your request will be reviewed before your personalized program is prepared.")}</p>
          </div>
          <div className="hpa-program-inquiry-card"><ProgramInquiryForm /></div>
        </div>
      </section>
    </div>
  );
};

export default ProgramInquiry;
